import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {DceComponent, debounce} from "dce-engine";
import {findFragmentParent, Fragment} from "dce-fragments";
import Dce from "dce-engine/lib/decorators/Dce";
import choices from "choices.js/public/types/src/scripts/reducers/choices";
import Choices from "choices.js";
import {Choice} from "choices.js/src/scripts/interfaces/choice";

interface WireChoicesProps {
    wireAction: string,
    addNewLabel?: string,
    newSubformSelector?: string
}

/**
 * Komponent do
 * https://github.com/Choices-js/Choices
 */
@Dce("WireChoices")
export default class WireChoices extends DceComponent<WireChoicesProps> {

    private choices: Choices;
    private parentFragment: Fragment;

    constructor(elem: DceHTMLElement, props: WireChoicesProps) {
        super(elem, props);
        this.parentFragment = findFragmentParent(elem);

        // @ts-ignore
        import(/* webpackChunkName: "choices-css" */ 'choices.js/public/assets/styles/choices.min.css');

        this.choices = new Choices(elem, {
            callbackOnCreateTemplates: () => ({
                // notice: (...args:any) => {
                //     let obj = Object.assign(Choices.defaults.templates.notice.call(this, ...args), {
                //         innerHTML: '<b>Dodaj nowy</b>',
                //     });
                //
                //     console.log("XXXXXXXXX", obj);
                //
                //     obj.classList.remove('has-no-results');
                //     obj.classList.add('choices__item--selectable');
                //     //obj.setAttribute('role')
                //
                //     obj.setAttribute('role', 'option');
                //
                //     //data-choice="" data-id="1" data-value="1" data-select-text="Press to select" data-choice-selectable=""
                //     obj.setAttribute('data-id', '0');
                //     obj.setAttribute('data-choice', '');
                //     obj.setAttribute('data-value', '0');
                //     obj.setAttribute('data-select-text', 'Press to create new');
                //     obj.setAttribute('data-choice-selectable', '');
                //
                //     return obj;
                // },

                choice: (...args:any) => {
                    let obj = Object.assign(Choices.defaults.templates.choice.call(this, ...args), {});

                    //console.log('CHX rndr', obj.getAttribute('data-value'));

                    return obj;
                }
            }),
        });

        this.elem.addEventListener('choice', (e:CustomEvent) => {
            //choice event listenr
            console.log('CHX', e);

            let chosen = (e.detail.choice as Choice)

            console.log('CHX event', chosen)

            if(chosen.value === '0'){

                this.parentFragment.updateDisplay(
                    this.props.newSubformSelector, 'block'
                );

                this.parentFragment.update(
                    this.props.newSubformSelector, {
                        disabled: false
                    }
                )

            }else{
                this.parentFragment.updateDisplay(
                    this.props.newSubformSelector, 'none'
                );

                this.parentFragment.update(
                    this.props.newSubformSelector, {
                        disabled: true
                    }
                )
            }

        })

        this.elem.addEventListener('search', debounce(async (e) => {
            let search = e.detail.value;

            let resp = await this.parentFragment.call(
                this.props.wireAction, {
                    q: search
                }
            );

            let data: Choice[] = [];
            if(resp.hasData("choices")){
                data = resp.data['choices'];
            }

            if(null != this.props.addNewLabel){
                data.push({
                    label: this.props.addNewLabel,
                    value: "0",
                    id: 0
                });
            }

            this.choices.setChoices(data, 'value', 'label', true);

        }, 100));

        if((this.elem as unknown as HTMLSelectElement).value === '0'){
            this.parentFragment.updateDisplay(
                this.props.newSubformSelector, 'block'
            );

            this.parentFragment.update(
                this.props.newSubformSelector, {
                    disabled: false
                }
            )
        }else{
            this.parentFragment.updateDisplay(
                this.props.newSubformSelector, 'none'
            );

            this.parentFragment.update(
                this.props.newSubformSelector, {
                    disabled: true
                }
            )
        }
    }
}